import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  function tranformCommPreferences(pref) {
    return {
      ...pref,
      type: pref.type === 'APPOINTMENT_MESSAGES' ? true : false,
    }
  }
  return useMemo(() => {
    if (!data) return data

    let insertedEmails = new Set()
    // this is to ensure if there are two duplicated emails one with comm preference set other with not
    // only with one with set gets inserted
    let filteredData = data.filter(d => {
      if (
        d.communication_preferences.map(tranformCommPreferences)?.[0] &&
        !insertedEmails.has(d.email.address)
      ) {
        insertedEmails.add(d.email.address)
        return true
      } else {
        return false
      }
    })

    data.forEach(d => {
      if (!insertedEmails.has(d.email.address)) {
        filteredData.push(d)
        insertedEmails.add(d.email.address)
      }
    })

    return filteredData
      .map(obj => ({
        ...obj,
        preference: !!obj?.preference,
        communication_preferences: obj.communication_preferences.map(
          tranformCommPreferences
        )?.[0],
      }))
      .sort((a, b) => a.id - b.id)
  }, [data])
}
